import { render, staticRenderFns } from "./instantreport.vue?vue&type=template&id=91ce4b1a&"
import script from "./instantreport.vue?vue&type=script&lang=js&"
export * from "./instantreport.vue?vue&type=script&lang=js&"
import style0 from "./instantreport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports